/* Iguala el boton de compra de Releasit al verde de los CTA del cuerpo de Armored Cash.
   Releasit escribe estilos inline con !important; la unica forma de sobreescribirlos es
   volver a poner el inline con setProperty(..., 'important'). Queda un MutationObserver
   por si la app repinta el boton al cambiar de variante o al hidratar. */
(function () {
  if (window.__acBoton) return;
  window.__acBoton = 1;

  var ESTILOS = {
    'border-radius': '10px',
    'border': '2px solid #000',
    'background': '#0EDA52',
    'box-shadow': '0 10px 26px rgba(14,218,82,.28)',
    'width': '100%',
  };

  function pinta(el) {
    if (!el) return;
    for (var k in ESTILOS) el.style.setProperty(k, ESTILOS[k], 'important');
  }

  function buscar() {
    var todos = document.querySelectorAll('#_rsi-buy-now-button, [id*="rsi-buy-now"]');
    for (var i = 0; i < todos.length; i++) {
      var e = todos[i];
      if (getComputedStyle(e).position === 'fixed') continue;
      pinta(e);
      vigila(e);
    }
  }

  function vigila(el) {
    if (el.__acObs) return;
    el.__acObs = 1;
    new MutationObserver(function () {
      if (el.style.borderRadius !== '10px') pinta(el);
    }).observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  var intentos = 0;
  var t = setInterval(function () {
    buscar();
    if (++intentos > 40) clearInterval(t);
  }, 250);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buscar);
  } else {
    buscar();
  }
})();
